module.exports = __webpack_public_path__ + "img/warning1.deafc6f9.svg";